import {
  UntypedFormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { OnboardingService } from "src/app/services/onboarding.service";
import { EditWarehouseComponent } from "src/app/modules/settings/edit-warehouse/edit-warehouse.component";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";

import { LogisticService } from "../../logistic.service";
import { PopupLocationSummeryComponent } from "../../custome-component/popup-location-summery/popup-location-summery.component";
declare var google;

@Component({
  selector: "app-warehouse-dialog",
  templateUrl: "./warehouse-dialog.component.html",
  styleUrls: ["./warehouse-dialog.component.scss"],
})
export class WarehouseDialogComponent implements OnInit, OnDestroy {
  // whForm: FormGroup = new FormGroup({
  //   warehouseId: new FormControl(0),
  //   addressName: new FormControl(""),
  //   addressLine: new FormControl(""),
  //   city: new FormControl(""),
  //   state: new FormControl(""),
  //   postal: new FormControl(""),
  //   country: new FormControl(""),
  //   countryCode: new FormControl(""),
  //   priorityLavel: new FormControl(1),
  //   pickStrategy: new FormControl(1),
  // });
  // private destroy$ = new Subject<void>();
  // public states: any[];

  // constructor(
  //   private authService: AuthService,
  //   private router: Router,
  //   private logisticsService: LogisticService,
  //   public dialogRef: MatDialogRef<WarehouseDialogComponent>,
  //   @Inject(MAT_DIALOG_DATA) public dialogData,
  //   private onboardingService: OnboardingService
  // ) {}

  // ngOnInit(): void {
  //   this.authService.userInfo$
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe((res: LoginModel) => {
  //       this.whForm.patchValue({ submittedBy: res.username });
  //     });

  //   if (this.dialogData) {
  //     var exdata;
  //     if (this.dialogData.data.WarehouseId > 0) {
  //       this.logisticsService
  //         .GetWhHouseByWhId(this.dialogData.data.WarehouseId)
  //         .subscribe((response: any) => {
  //           if (response) {
  //             exdata = response;
  //             this.whForm.addControl("warehouseId", new FormControl());
  //             this.whForm.patchValue({
  //               warehouseId: exdata?.warehouseId,
  //               name: exdata?.Name,
  //               addressName: exdata?.addressName,
  //               addressLine: exdata?.addressLine1,
  //               pickStrategy: exdata?.pickStrategy,
  //               priorityLavel: exdata?.priorityLavel,
  //               postal: exdata?.zipCode,
  //               state: exdata?.state,
  //               city: exdata?.city,
  //               country: exdata?.country,
  //             });
  //           }
  //         });
  //     }
  //   } else {
  //     this.whForm.patchValue({
  //       warehouseId: 0,
  //     });
  //   }
  // }

  // action(e): void {
  //   if (e === "Save") {
  //     this.save();
  //   } else {
  //     this.dialogRef.close(e);
  //   }
  // }

  // save(): void {
  //   const payload = this.whForm.value;
  //   this.logisticsService
  //     .SaveWarehouse(payload)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(() => {
  //       this.dialogRef.close(true);
  //     });

  //   this.dialogRef.close();
  // }

  // ngOnDestroy(): void {
  //   this.destroy$.next();
  //   this.destroy$.unsubscribe();
  // }
  public warehouseForm = this.fb.group({
    // Id: ["", Validators.required],
    Name: ["", Validators.required],
    AddressName: ["", Validators.required],
    AddressLine: ["", Validators.required],
    AddressLine2: [""],
    // City: [""],
    // State: [""],
    // Zipcode: [null],
    // Country: [""],
    // CountryCode: [""],
    PriorityLavel: [1],
    PickStrategy: [],
    FulfillsFba: [false],
    FulfillsFbm: [false],
    FulfillsVendorCenter: [false],
    // Picktp: [0],
    PickingEnabled: [false],
    EnabledLocationsOnly: [false],
  });
  public uniqueId = false;
  public loadingUniqueId = false;
  public checkedUniqueId = false;
  public setTimeoutInter: any;
  private destroy$ = new Subject<void>();
  public states: any[];
  public pickStrategies: any[];

  // for google address .........................................
  address: { [key: string]: string };
  addressTypes = [
    { key: "AddressLine", type: "street_number" },
    { key: "AddressLine", type: "route" },
    { key: "AddressLine", type: "neighborhood" },
    { key: "address2", type: "sublocality_level_2" },
    { key: "address2", type: "sublocality_level_1" },
    { key: "address2", type: "locality" },
    { key: "city", type: "administrative_area_level_2" },
    { key: "state", type: "administrative_area_level_1" },
    { key: "postal", type: "postal_code" },
    { key: "country", type: "country" },
  ];

  @ViewChild("addressText") addressText: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EditWarehouseComponent>,
    public fb: UntypedFormBuilder,
    private onboardingService: OnboardingService,
    private logisticsService: LogisticService,
    private snackBar: MatSnackBar,
    public dialogRefNew: MatDialogRef<PopupLocationSummeryComponent>,
    private logisticService: LogisticService
  ) {}

  ngOnInit() {
    if (this.data.type === "edit") {
      if (this.data && this.data.WarehouseId > 0) {
        this.logisticService
          .GetWhHouseByWhId(this.data.WarehouseId)
          .pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
            if (response) {
              this.data = response;
              this.warehouseForm.addControl(
                "WarehouseId",
                new FormControl((this.data.WarehouseId, Validators.required))
              );
              this.warehouseForm.patchValue({
                Name: this.data.name,
                AddressName: this.data.addressName,
                AddressLine2:this.data.addressLine2,
                AddressLine: this.data.addressLine1 + ' ,'+this.data.city+ ' ,'+this.data.state+' ,'+this.data.country,
                PriorityLavel: this.data?.priorityLavel,
                PickStrategy: this.data?.pickStrategy,
                FulfillsFba: this.data?.fulfillsFba,
                FulfillsFbm: this.data.fulfillsFbm,
                EnabledLocationsOnly: this.data.enabledLocationsOnly,
                FulfillsVendorCenter: this.data.fulfillsVendorCenter,
                PickingEnabled: this.data.pickingEnabled,
              });
              this.address = {
                AddressLine: this.data.addressLine1,
                address2: this.data.address2,
                city: this.data.city,
                state: this.data.state,
                postal: this.data.postal,
                country: this.data.country,
              };
            }
          });
      }

      // const tempArray = Object.keys(this.data);
      // if (tempArray.indexOf("addName") > -1) {
      //   tempArray.splice(tempArray.indexOf("addName"), 1);
      // }

      // tempArray.forEach((key, index) => {
      //   if (index !== 0) {
      //     tempObject = {
      //       ...tempObject,
      //       ...{
      //         [key.split("")[0].toUpperCase() +
      //         key.split("").slice(1).join("")]: this.data[key],
      //       },
      //     };
      //   }
      // });
      // tempObject = {
      //   ...tempObject,
      //   ...{
      //     Isfba: this.numberToBoolean(tempObject.Isfba),
      //     Isfbm: this.numberToBoolean(tempObject.Isfbm),
      //   },
      // };

      //this.warehouseForm.patchValue(tempObject);
    }
    // this.getStatesByCountryCode(
    //   this.data.CountryCode ? this.data.CountryCode : "US"
    // );

    // this.warehouseForm
    //   .get("CountryCode")
    //   .valueChanges.subscribe((countryCode) => {
    //     this.getStatesByCountryCode(countryCode);
    //   });
    this.pickStrategies = this.getPickStrategy();
    this.warehouseForm.get("AddressLine").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (!value) {
        this.resetAddressData();
      }
    });
  }

  // for google address start ..................................................

  ngAfterViewInit(): void {
    this.getPlaceAutocomplete();
  }

  getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addressText.nativeElement,
      { types: ["address"] }
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      this.setAddressData(place);
    });
  }
  setAddressData(place): void {
    this.resetAddressData();
    this.addressTypes.forEach((res) => {
      const data = place.address_components.find((address) =>
        address.types.includes(res.type)
      )?.long_name;
      if (data)
        this.address[res.key] = (this.address[res.key] + " " + data).trim();
    });
  }

  resetAddressData(): void {
    this.address = {
      address1: "",

      AddressLine: "",
      address2: "",
      city: "",
      state: "",
      postal: "",
      country: "",
    };
  }

  // for google address end ..................................................

  getStatesByCountryCode(countryCode): void {
    if (countryCode === "US") {
      // this.warehouseForm.get('CountryCode').setValue('US')
      this.getStates();
      this.warehouseForm.get("Country").setValue("United States");
    } else if (countryCode === "CA") {
      // this.warehouseForm.get('CountryCode').setValue('CA')
      this.states = this.getProvinces();
      this.warehouseForm.get("Country").setValue("Canada");
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  getStates = () => {
    this.onboardingService.getStates().pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {
      this.states = data;
    });
  };
  getPickStrategy = () => {
    return [
      {
        name: "First In First Out",
      },
      {
        name: "First In Last Out",
      },
      {
        name: "All From 1 Location",
      },
      {
        name: "Empty Out Locations",
      },
      {
        name: "Shortest Route",
      },
    ];
  };
  getProvinces = () => {
    return [
      {
        name: "Alberta",
        abbreviation: "AB",
      },
      {
        name: "British Columbia",
        abbreviation: "BC",
      },
      {
        name: "Manitoba",
        abbreviation: "MB",
      },
      {
        name: "New Brunswick",
        abbreviation: "NB",
      },
      {
        name: "Newfoundland and Labrador",
        abbreviation: "NL",
      },
      {
        name: "Northwest Territories",
        abbreviation: "NT",
      },
      {
        name: "Nova Scotia",
        abbreviation: "NS",
      },
      {
        name: "Nunavut",
        abbreviation: "NU",
      },
      {
        name: "Ontario",
        abbreviation: "ON",
      },
      {
        name: "Prince Edward Island",
        abbreviation: "PE",
      },
      {
        name: "Quebec",
        abbreviation: "QC",
      },
      {
        name: "Saskatchewan",
        abbreviation: "SK",
      },
      {
        name: "Yukon Territory",
        abbreviation: "YT",
      },
    ];
  };

  public warehouseFormSubmit() {    
    const tempData = this.warehouseForm.value;
    const formData = {
      ...tempData,
      ...{
        // Isfba: this.booleanToNumber(tempData.Isfba),
        // Isfbm: this.booleanToNumber(tempData.Isfbm),
        // FulfillsFba: this.booleanToNumber(tempData.FulfillsFba),
        // FulfillsFbm: this.booleanToNumber(tempData.FulfillsFbm),
        // FulfillsVendorCenter: this.booleanToNumber(
        //   tempData.FulfillsVendorCenter
        // ),
        // PickingEnabled: this.booleanToNumber(tempData.PickingEnabled),
      },
    };

    formData.FulfillsFba = this.warehouseForm.controls.FulfillsFba.value;
    formData.FulfillsFbm = this.warehouseForm.controls.FulfillsFbm.value;
    formData.FulfillsVendorCenter =
      this.warehouseForm.controls.FulfillsVendorCenter.value;
    formData.PickingEnabled = this.warehouseForm.controls.PickingEnabled.value;
    formData.EnabledLocationsOnly =
      this.warehouseForm.controls.EnabledLocationsOnly.value;

    formData.Country = this.address.country;
    formData.State = this.address.state;
    formData.Zipcode = this.address.postal;
    formData.AddressLine = this.address.AddressLine;

    if (this.data.warehouseId > 0) {
      formData.warehouseId = this.data.warehouseId;
    } else {
      formData.warehouseId = 0;
    }
    this.logisticsService
      .SaveWarehouse(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: `Warehouse ` + (this.data ? "updated" : "added") + ` successfully`,
            action: 'Dismiss',
            type: 'info',
          },
        });
        this.dialogRef.close(true);
      });
  }

  public updateWarehouseFormSubmit() {
    const tempData = this.warehouseForm.value;
    const formData = {
      ...tempData,
      ...{
        Isfba: this.booleanToNumber(tempData.Isfba),
        Isfbm: this.booleanToNumber(tempData.Isfbm),
      },
    };
    formData.WarehouseId = this.data != null ? this.data.WarehouseId : 0;
    this.logisticsService
      .SaveWarehouse(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.dialogRef.close(true);
      });
  }

  // public checkId($e) {
  //   const value = $e.target.value;
  //   this.uniqueId = false;
  //   this.checkedUniqueId = false;
  //   this.loadingUniqueId = true;
  //   if (value !== "") {
  //     clearTimeout(this.setTimeoutInter);
  //     this.setTimeoutInter = setTimeout(() => {
  //       this.settingsService
  //         .GetWarehouse(value)
  //         .pipe(takeUntil(this.destroy$))
  //         .subscribe(
  //           (data) => {
  //             this.loadingUniqueId = false;
  //             if (data === null) {
  //               this.uniqueId = true;
  //               this.checkedUniqueId = true;
  //             } else {
  //               this.uniqueId = false;
  //               this.checkedUniqueId = true;
  //             }
  //           },
  //           (err) => {
  //             this.loadingUniqueId = false;
  //           }
  //         );
  //     }, 1000);
  //   }
  // }

  public booleanToNumber = (data) => (data === false ? 0 : 1);

  public numberToBoolean = (data) => (data === 0 ? false : true);

  dialogAction(e) {
    if (e === "Save" || e === "Update") {
      this.warehouseFormSubmit();
    } else {
      this.close();
    }

    // if (e === "Save") {
    //   this.warehouseFormSubmit();
    // } else if (e === "Update") {
    //   this.updateWarehouseFormSubmit();
    // } else {
    //   this.close();
    // }
  }
  close() {
    this.dialogRef.close();
  }
}
